import { CategoryProductsCarouselsQueries } from 'src/dispensary/hooks/use-category-products-for-carousels-queries';

// Every query param that narrows the bare /products (all-products) list down to a subset,
// whether via the search box or any of the menu sidebar filters (brand, subcategory, strain
// type, potency, effects, terpenes, weight, specials). Kept in sync with the filter keys
// defined in use-product-query-params.js.
const FILTER_QUERY_PARAM_KEYS = [
  'search',
  'category',
  'subcategories',
  'brands',
  'straintypes',
  'weight',
  'effects',
  'terpenes',
  'specialFilter',
  'potencythc',
  'potencycbd',
] as const;

export function hasActiveProductFilters(queryParams: Record<string, unknown>): boolean {
  return FILTER_QUERY_PARAM_KEYS.some((key) => {
    const value = queryParams[key];
    return Array.isArray(value) ? value.length > 0 : Boolean(value);
  });
}

type ShowInterstitialCarousels = {
  showSponsoredBrandsCarousel: boolean;
  showCategoryRecommendationsCarousel: boolean;
};

export function getShowInterstitialCarousels(
  productsCarouselQueries?: CategoryProductsCarouselsQueries
): ShowInterstitialCarousels {
  const { sponsoredBrandQuery, personalizedProductsQuery } = productsCarouselQueries ?? {
    sponsoredBrandQuery: { data: { getSponsoredBrand: { products: null } }, loading: false, error: null },
    personalizedProductsQuery: { data: { getPersonalizedProducts: { products: null } }, loading: false, error: null },
  };

  const showSponsoredBrandsCarousel =
    !sponsoredBrandQuery.loading &&
    !sponsoredBrandQuery.error &&
    !!sponsoredBrandQuery.data?.getSponsoredBrand?.products?.length;

  const showCategoryRecommendationsCarousel =
    !personalizedProductsQuery.loading &&
    !personalizedProductsQuery.error &&
    !!personalizedProductsQuery.data?.getPersonalizedProducts?.products?.length;

  return {
    showSponsoredBrandsCarousel,
    showCategoryRecommendationsCarousel,
  };
}
